/* eslint-disable jsx-a11y/anchor-is-valid */
import { useContext, useState } from "react";
import appStyles from "../../../App.module.css";
import { formatAmount, formatDate } from "../../../app-constants";
import { AUBusinessTravelContext } from "../../AUBusinessTravel";
import {
  PreviewPolicyAU,
  businessTravelAUDocs,
} from "../../config/bt-constants";
import { IAUBusinessTravelContext } from "../../config/interfaces";
import Popup from "../Popup";
import ArrowOutward from "../icons/ArrowOutward";
import BenefitSummaryTableModal from "../modal/BenefitSummaryTableModal";
import EditCurrencyAndCompany from "./EditCurrencyAndCompany";
type QuoteSummaryProps = {
  showPolicyTerm?: boolean;
  Premium?: boolean;
};
const QuoteSummary = (props: QuoteSummaryProps) => {
  const { showPolicyTerm = false, Premium = false } = props;
  const [showCurrencyEditor, setShowCurrencyEditor] = useState<boolean>(false);
  const [showBenefitSummaryModal, setShowBenefitSummaryModal] = useState<boolean>(false);

  const { quoteData, currentStep, quoteResult, version, order } = useContext(
    AUBusinessTravelContext
  ) as IAUBusinessTravelContext;
  return (
    <>
      <div className={` ${appStyles.btQuoteResultWrapper}`}>
        <div className={`${appStyles.quoteTotalBoxOuter} ${appStyles.btQuoteTotalBoxOuter}`}>
          <div className={`${appStyles.btBorderBox} ${appStyles.btQuoteTotalBox}`}>
            <div className={` ${appStyles.quoteSummaryWrapper}`}>
              <h3 className={appStyles.btTitle}>Business Travel Plan</h3>

              {/* <div>
                <div className={`${appStyles.btQuoteTripPlanDetail}`}>
                  <h5 className={appStyles.btPlanLabel}>Premium</h5>
                  <span className={`${appStyles.btPlanAmount} ${appStyles.btMargin0}`}>
                    {formatAmount(
                      Premium
                        ? order?.premium
                        : Number(quoteResult?.quoted_price) - Number(quoteResult?.taxes?.tax) || 0,
                      "AU",
                      "AUD"
                    )}
                  </span>
                </div>
                <div className={`${appStyles.btQuoteTripPlanDetail}`}>
                  <h5 className={appStyles.btPlanLabel}>Taxes</h5>
                  <span className={`${appStyles.btPlanAmount} ${appStyles.btMargin0}`}>
                    {formatAmount(quoteResult?.taxes?.tax || 0, "AU", "AUD")}
                  </span>
                </div>
                <div className={`${appStyles.btQuoteTripPlanDetail}`}>
                  <h5 className={appStyles.btPlanLabel}>
                    Total
                    {currentStep !== 3 ? (
                      <>
                        &nbsp; (
                        <span>
                          AUD
                        </span>
                        )
                      </>
                    ) : null}
                  </h5>
                  <span className={`${appStyles.btPlanAmount} ${appStyles.btMargin0}`}>
                    {formatAmount(quoteResult?.quoted_price || 0, "AU", "AUD")}
                  </span>
                </div>
                {showCurrencyEditor && (
                  <Popup
                    onClose={() => {
                      setShowCurrencyEditor(false);
                    }}
                    title="Preferred currency"
                    showTitle={false}
                    children={
                      <EditCurrencyAndCompany
                        itemsArray={currencyDropDown}
                        closeModel={setShowCurrencyEditor}
                        type="currency"
                      />
                    }
                  />
                )}
              </div> */}
              {(
                <>
                  <hr className={appStyles.btHrStyle} />
                  <div className={appStyles.quoteTotalSummaryWrapper}>
                    <h1 className={appStyles.colorPrimary}>
                      {formatAmount(quoteResult?.quoted_price || 0, "AU", "AUD")}
                    </h1>
                    <small className={appStyles.priceText}>Total incl. gov’t fees & charges</small>
                  </div>
                </>
              )}
              <hr className={appStyles.btHrStyle} />
              {(
                <div className={`${appStyles.paymentButtonWrapper} ${appStyles.btSummaryLinkWrap}`}>
                  <a
                    className={`${appStyles.bfSummaryLinkButton}`}
                    rel="noopener noreferrer"
                    onClick={() => setShowBenefitSummaryModal(true)} //TODO: update this when we get text
                  >
                    See benefits summary
                  </a>

                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href={PreviewPolicyAU[`${quoteData?.currency}`]}
                    className={`${appStyles.bfSummaryLinkButton}`}
                  >
                    Preview policy <ArrowOutward />
                  </a>
                  <a
                    href={businessTravelAUDocs?.MarketDetermination}
                    target="_blank"
                    rel="noopener noreferrer"
                    className={`${appStyles.bfSummaryLinkButton}`}
                  >
                    View Target Market Determination <ArrowOutward />
                  </a>
                </div>
              )}
            </div>
          </div>

          {showBenefitSummaryModal && (
            <Popup
              onClose={() => {
                setShowBenefitSummaryModal(false);
              }}
              title=""
              styleBenefitModal={true}
              children={<BenefitSummaryTableModal version={version} quoteData={quoteData} />}
            />
          )}
        </div>
      </div>
    </>
  );
};

export default QuoteSummary;
